var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AInlineEditable from '@/components/InlineEditable/InlineEditable';
import StatusIcon from '@/components/StatusIcon.vue';
import { Lvs } from '@/models/Lvs';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { Student } from '@/models/Student';
import AlertCard from '@/components/alert-card/AlertCard';
import { userReportGoals } from '@/models/User';
import { cloneDeep } from 'lodash';
let StudentReportTable = class StudentReportTable extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.studentData = null;
        this.userGoals = userReportGoals;
        this.panelOpen = false;
    }
    mounted() {
        if (this.area && this.area.users) {
            // this.areaClone = cloneDeep(this.area);
            this.studentData = cloneDeep(this.area.users[this.$route.params.id]);
        }
        this.isLoading = false;
    }
    async onUpdateDescription(event) {
        if (!(this.$route.params && this.$route.params.id)) {
            return;
        }
        const response = await new Student({ id: this.$route.params.id })
            .setLvsAreasEndpoint()
            .create({
            subject_id: this.area.id,
            notes: event.value,
        })
            .catch(() => {
            event.setFailedState();
            return;
        });
        if (this.studentData) {
            this.studentData.notes = response.notes;
            event.setSuccessState();
            return;
        }
        event.setFailedState();
    }
    async onUpdateTopicScore(event, period) {
        if (!(this.$route.params && this.$route.params.id)) {
            return;
        }
        await new Student({ id: this.$route.params.id })
            .setLvsResultsEndpoint()
            .create({
            area_id: this.area.id,
            lvs_period_id: period.id,
            score: event.value,
        })
            .catch(() => {
            event.setFailedState();
            return;
        });
        event.setSuccessState();
    }
    async onUpdateGoal(value, area) {
        const response = await new Student({ id: this.$route.params.id })
            .setLvsAreasEndpoint()
            .create({
            subject_id: area.id,
            goal: value,
        });
        if (!response && this.area && this.area.users) {
            this.isLoading = true;
            this.studentData = null;
            this.$nextTick(() => {
                this.studentData = cloneDeep(this.area.users[this.$route.params.id]);
            });
            this.isLoading = false;
        }
    }
    async onUpdateTopicScorePercentage(event, period) {
        if (!(this.$route.params && this.$route.params.id)) {
            return;
        }
        await new Student({ id: this.$route.params.id })
            .setLvsResultsEndpoint()
            .create({
            area_id: this.area.id,
            lvs_period_id: period.id,
            reference_percentage: event.value,
        })
            .catch(() => {
            event.setFailedState();
            return;
        });
        event.setSuccessState();
    }
    findPeroidTopicIntersection(period, topic) {
        const lookUpPeroids = topic.users[this.$route.params.id].periods;
        if (!lookUpPeroids) {
            return;
        }
        const foundPeriod = Object.keys(lookUpPeroids).find((lookupPeriod) => lookupPeriod === period.id);
        if (foundPeriod) {
            return lookUpPeroids[foundPeriod].data;
        }
        return null;
    }
    revealAllChanged() {
        if (this.revealAll) {
            this.panelOpen = true;
        }
        else {
            this.panelOpen = false;
        }
    }
};
__decorate([
    Prop({ default: () => new Lvs() }),
    __metadata("design:type", typeof (_a = typeof Lvs !== "undefined" && Lvs) === "function" ? _a : Object)
], StudentReportTable.prototype, "area", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], StudentReportTable.prototype, "revealAll", void 0);
__decorate([
    Watch('revealAll'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StudentReportTable.prototype, "revealAllChanged", null);
StudentReportTable = __decorate([
    Component({
        components: {
            AInlineEditable,
            StatusIcon,
            LoaderCard,
            AlertCard,
        },
    })
], StudentReportTable);
export default StudentReportTable;
